export const SUPPORT_COMMENT_ADDED = "SUPPORT_COMMENT_ADDED";
export const SUPPORT_CONFIRM_RESOLVED = "SUPPORT_CONFIRM_RESOLVED";
export const SUPPORT_RESOLVED = "SUPPORT_CONFIRM_RESOLVED";
export const SUPPORT_RESPONSE_SUBMITTED = "SUPPORT_RESPONSE_SUBMITTED";
export const SUPPORT_FORWARDED = "SUPPORT_FORWARDED";
export const SUPPORT_SNOOZED = "SUPPORT_SNOOZED";
export const SUPPORT_RATED = "SUPPORT_RATED";
